import type {
	GetBenchmarkMyCommunitiesQuery,
	GetBenchmarkMyFirmsQuery,
	GetBenchmarkSubmissionsQuery,
	GetBenchmarkSubmissionsQueryVariables
} from "~/gql/queries/benchmark.generated";
import type { GetBenchmarkRetailMonthsQuery } from "~/gql/queries/benchmarkRetailMonth.generated";

import {
	mergeBenchmarkSubmissionPages,
	serializeBenchmarkSubmissionsQueryKey
} from "~benchmark/helpers/benchmarkHomeHelpers";

export const benchmarkEndpoints = {
	GetBenchmarkMyCommunities: {
		providesTags: ["BenchmarkCommunities"] as AddTagTypes,
		transformResponse: (res: GetBenchmarkMyCommunitiesQuery) => res
	},
	GetBenchmarkMyFirms: {
		providesTags: ["BenchmarkFirms"] as AddTagTypes,
		transformResponse: (res: GetBenchmarkMyFirmsQuery) => res
	},
	GetBenchmarkRetailMonths: {
		providesTags: ["BenchmarkRetailMonths"] as AddTagTypes,
		transformResponse: (res: GetBenchmarkRetailMonthsQuery) => res
	},
	GetBenchmarkSubmissions: {
		forceRefetch({
			currentArg,
			previousArg
		}: {
			currentArg: GetBenchmarkSubmissionsQueryVariables | undefined;
			previousArg: GetBenchmarkSubmissionsQueryVariables | undefined;
		}) {
			return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
		},
		merge(
			currentCache: GetBenchmarkSubmissionsQuery,
			newData: GetBenchmarkSubmissionsQuery,
			{ arg }: { arg: GetBenchmarkSubmissionsQueryVariables }
		): GetBenchmarkSubmissionsQuery {
			if (!newData) return currentCache;
			return {
				...newData,
				benchmarkSubmissions: mergeBenchmarkSubmissionPages(
					currentCache?.benchmarkSubmissions ?? [],
					newData.benchmarkSubmissions,
					!arg.after
				)
			};
		},
		providesTags: ["BenchmarkSubmissions"] as AddTagTypes,
		serializeQueryArgs: ({
			endpointName,
			queryArgs
		}: {
			endpointName: string;
			queryArgs: GetBenchmarkSubmissionsQueryVariables;
		}) => serializeBenchmarkSubmissionsQueryKey(endpointName, queryArgs),
		transformResponse: (res: GetBenchmarkSubmissionsQuery) => res
	},
	SetBenchmarkRetailMonthValues: {
		invalidatesTags: ["BenchmarkRetailMonths", "BenchmarkSubmissions"] as AddTagTypes
	}
};
